// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"2340981e","469":"d1b65c97","669":"231115ef","703":"9504e8bf","787":"385972ca"}[chunkId] + ".chunk.js";
};